export default "__VITE_PUBLIC_ASSET__86739d82__"